module.exports = __webpack_public_path__ + "img/zhxy_image.e6dfc56b.png";